import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'computeSpaces'
})
export class MWordsPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string): SafeHtml {
    const result = value.replace(new RegExp(' ', 'gm'), 'θ');
    return this.sanitizer.bypassSecurityTrustHtml(
      this.replaceSpaces(result).replace(new RegExp('θ', 'gm'), '<span class="m-word"></span>') as string
    );
  }

  replaceSpaces(str: string): string {
    let newStr = '';
    let tmpStr = '';
    let cntRept = 0;
    let lastChar = '';
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < str.length; i++) {
      tmpStr += str[i];
      if (str[i] === 'θ' && lastChar === str[i]) {
        cntRept++;
        if (i === str.length - 1 && cntRept + 1 > 5) {
          newStr = '';
          newStr += tmpStr.substr(0, tmpStr.length - cntRept - 1);
          newStr += `θ<span class="m-word-number">+${cntRept.toString()}</span>`;
          tmpStr = newStr;
        }
      } else {
        if (cntRept + 1 > 5) {
          newStr = '';
          newStr += tmpStr.substr(0, tmpStr.length - cntRept - 2);
          newStr += `θ<span class="m-word-number">+${cntRept.toString()}</span>`;
          tmpStr = newStr + str[i];
        }
        cntRept = 0;
      }
      lastChar = str[i];
    }
    return tmpStr;
  }
}
